
import WMTS, {optionsFromCapabilities} from 'ol/source/WMTS.js';
import WMTSCapabilities from 'ol/format/WMTSCapabilities.js';
import TileLayer from "ol/layer/Tile";
import TileWMS from "ol/source/TileWMS";
import TileGrid from "ol/tilegrid/TileGrid";
import { Projection } from 'ol/proj';

export function getDigitalOrtoPhoto() {
    const layer = new TileLayer({
        opacity: 1,
        title: 'Digital ortho photo',
        visible: true,
        showInSwitcher: true
    });

    getCapabilities(
        'https://ipi.eprostor.gov.si/gwc-si-gurs-dts/service/wmts?SERVICE=WMTS&REQUEST=GetCapabilities',
        'SI.GURS.ZPDZ:PREGLEDNI_DOF'
    )
    .then(options => {
        layer.setSource(new WMTS(options));
    })
    .catch(error => {
        console.error('Error loading Digital ortho photo WMTS layer:', error);
    });

    return layer;
}

export function getGursTopoWMS() {

    // Define the extent (from capabilities)
    const extent = [293225.0, -108924.99999999994, 830824.9999999999, 249475.0];

    // Define the projection with the extent
    const projection = new Projection({
        code: 'EPSG:3794',
        extent: extent,
        units: 'm',
        axisOrientation: 'neu'
    });

    // Define the tile grid (resolutions are copied from other capabilities file for WMTS, as they are missing in WMS capabilities)
    const resolutions = [699.9999999999999, 419.99999999999994, 280.0, 209.99999999999997, 140.0, 97.99999999999999, 70.0, 48.99999999999999, 27.999999999999996, 13.999999999999998, 11.2, 6.999999999999999, 2.8, 1.4, 0.7, 0.27999999999999997];
    const tileGrid = new TileGrid({
        origin: [extent[0], extent[3]], // top-left corner
        resolutions: resolutions,
        tileSize: [256, 256],
        extent: extent
    });


    return new TileLayer({
        title: 'GURS topo map',
        showInSwitcher: true,
        visible: false,
        source: new TileWMS({
            url: "https://ipi.eprostor.gov.si/gwc-si-gurs-dts/service/wms",
            params: {
                REQUEST: "GetMap",
                SERVICE: "WMS",
                VERSION: "1.1.1",
                FORMAT: "image/png",
                TRANSPARENT: true,
                LAYERS: "SI.GURS.DK:OSK",
                REFERER_APP_CODE: "JV",
                tiled: true,
                WIDTH: 256,
                HEIGHT: 256,
                SRS: "EPSG:3794",
            },
            projection: projection,
            tileGrid: tileGrid,
        })
    });
}

export function getGursTopoWMTS() {

    // Create the layer without a source initially
    const layer = new TileLayer({
        opacity: 1,
        title: 'GURS topo map',
        visible: false,
        showInSwitcher: true
    });

    // Start loading the capabilities in the background
    getCapabilities(
        'https://ipi.eprostor.gov.si/gwc-si-gurs-dts/service/wmts?request=getcapabilities',
        'SI.GURS.DK:OSK'
    )
    .then(options => {
        layer.setSource(new WMTS(options));

    })
    .catch(error => {
        console.error('Error loading GURS DK layer:', error);

    });

    // Return the layer immediately
    return layer;
}

export function getBaseLayers() {
    return [
        getDigitalOrtoPhoto(),
        getGursTopoWMS()
    ];
}

/**
 * Fetches and parses WMTS capabilities from the given URL, then extracts options for the specified layer.
 *
 * @async
 * @function
 * @param {string} url - The URL to the WMTS capabilities XML.
 * @param {string} layer - The name of the layer to extract options for.
 * @returns {Promise<Object>} A promise that resolves to the options extracted from the WMTS capabilities for the specified layer.
 */
async function getCapabilities(url, layer) {

    const parser = new WMTSCapabilities();

    const response = await fetch(url);
    const text = await response.text();

    const result = parser.read(text);

    return optionsFromCapabilities(result, { layer });
}
